/* Minik Moon — Widerruf + DHL-Retoure-Portal
 * Phase 1: § 356a BGB Widerruf-Eingangsbestätigung (Klaviyo Dual-Track)
 * Phase 2: DHL-Retourenlabel direkt im Widerruf-Form (Backend-API)
 *
 * Phase 2 aktiviert sich nur wenn `window.MINIKMOON_RETOURE_API` gesetzt ist
 * (sonst graceful Fallback auf Phase 1: Klaviyo-Mail, kein Backend-Call).
 * Stable Tunnel-URL kommt nach Cloudflare-Account-Setup.
 */
(function () {
  'use strict';

  // === CONFIG ===
  var KLAVIYO_COMPANY_ID = 'Xuikjg';
  var KLAVIYO_EVENT_NAME = 'Widerruf eingegangen';
  var KLAVIYO_API_REVISION = '2024-10-15';
  var KLAVIYO_EVENTS_ENDPOINT = 'https://a.klaviyo.com/client/events/?company_id=' + KLAVIYO_COMPANY_ID;
  var RETOURE_EMAIL = 'retoure@minikmoon.com';

  // Phase 2 Backend (Cloudflare Tunnel auf Mac mini → DHL-API)
  // Wird in theme.liquid via window.MINIKMOON_RETOURE_API gesetzt sobald stabile URL da ist.
  // Fallback: Phase 2 deaktiviert (Phase 1 läuft solo).
  var RETOURE_API = window.MINIKMOON_RETOURE_API || null;
  var PHASE2_ENABLED = !!RETOURE_API;

  if (!/\/policies\/refund-policy/i.test(window.location.pathname)) return;
  if (window.__minikmoonWiderrufInitialized) return;
  window.__minikmoonWiderrufInitialized = true;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    var anchor = findInsertionAnchor();
    if (!anchor) {
      console.warn('[Minik Moon Widerruf] Kein Anchor gefunden.');
      return;
    }
    var trigger = buildTrigger();
    var modal = buildModal();
    anchor.parentNode.insertBefore(trigger, anchor);
    document.body.appendChild(modal);
    attachListeners(trigger, modal);
  }

  function findInsertionAnchor() {
    var candidates = [
      '.shopify-policy__body',
      '.shopify-policy__container .rte',
      '.policy__content',
      'main .rte',
      'main h1',
      '#MainContent .rte',
      '#MainContent h1'
    ];
    for (var i = 0; i < candidates.length; i++) {
      var el = document.querySelector(candidates[i]);
      if (el && el.parentNode) return el;
    }
    return null;
  }

  function buildTrigger() {
    var wrapper = document.createElement('div');
    wrapper.className = 'widerruf-trigger';
    var hint = PHASE2_ENABLED
      ? 'In 2 Schritten erledigt — wir senden dir sofort eine Eingangsbestätigung und (wenn möglich) ein DHL-Retourenlabel.'
      : 'In 2 Schritten erledigt — sobald du absendest, bestätigen wir den Eingang sofort per E-Mail.';
    wrapper.innerHTML =
      '<h2 class="widerruf-trigger__heading">Du möchtest deinen Kauf widerrufen?</h2>' +
      '<p class="widerruf-trigger__hint">' + hint + '</p>' +
      '<button type="button" class="widerruf-button" aria-haspopup="dialog" aria-controls="minikmoon-widerruf-modal">' +
        '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false">' +
          '<path d="M16 4L8 12L4 8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>' +
        'Vertrag widerrufen' +
      '</button>';
    return wrapper;
  }

  function buildModal() {
    var modal = document.createElement('div');
    modal.className = 'widerruf-modal';
    modal.id = 'minikmoon-widerruf-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'widerruf-modal-title');
    modal.hidden = true;

    var addressFields = PHASE2_ENABLED ? (
      '<fieldset class="widerruf-fieldset">' +
        '<legend>Versandadresse (für Retourenlabel)</legend>' +
        '<div class="widerruf-field">' +
          '<label class="widerruf-field__label" for="widerruf-street">Straße + Hausnummer *</label>' +
          '<input class="widerruf-field__input" type="text" id="widerruf-street" name="street" required autocomplete="street-address" placeholder="Musterstraße 12">' +
          '<span class="widerruf-field__error">Bitte gib deine Adresse ein.</span>' +
        '</div>' +
        '<div class="widerruf-row">' +
          '<div class="widerruf-field widerruf-field--zip">' +
            '<label class="widerruf-field__label" for="widerruf-zip">PLZ *</label>' +
            '<input class="widerruf-field__input" type="text" id="widerruf-zip" name="zip" required autocomplete="postal-code" pattern="[0-9]{5}" inputmode="numeric">' +
            '<span class="widerruf-field__error">5-stellige PLZ.</span>' +
          '</div>' +
          '<div class="widerruf-field widerruf-field--city">' +
            '<label class="widerruf-field__label" for="widerruf-city">Ort *</label>' +
            '<input class="widerruf-field__input" type="text" id="widerruf-city" name="city" required autocomplete="address-level2">' +
            '<span class="widerruf-field__error">Bitte gib deinen Ort ein.</span>' +
          '</div>' +
        '</div>' +
        '<div class="widerruf-field">' +
          '<label class="widerruf-field__label" for="widerruf-phone">Telefon (optional)</label>' +
          '<input class="widerruf-field__input" type="tel" id="widerruf-phone" name="phone" autocomplete="tel">' +
          '<span class="widerruf-field__hint">Nur für Rückfragen.</span>' +
        '</div>' +
      '</fieldset>'
    ) : '';

    modal.innerHTML =
      '<div class="widerruf-modal__backdrop" aria-hidden="true"></div>' +
      '<div class="widerruf-modal__box">' +
        '<button type="button" class="widerruf-modal__close" aria-label="Fenster schließen">&times;</button>' +
        '<div class="widerruf-step widerruf-step--form" data-step="1">' +
          '<h2 id="widerruf-modal-title" class="widerruf-modal__title">Vertrag widerrufen</h2>' +
          '<p class="widerruf-modal__intro">Fülle bitte die Felder unten aus. Wir bestätigen den Eingang sofort per E-Mail.</p>' +
          '<form id="widerruf-form" class="widerruf-form" novalidate>' +
            '<div class="widerruf-field">' +
              '<label class="widerruf-field__label" for="widerruf-name">Vor- und Nachname *</label>' +
              '<input class="widerruf-field__input" type="text" id="widerruf-name" name="name" required autocomplete="name">' +
              '<span class="widerruf-field__error">Bitte gib deinen Namen ein.</span>' +
            '</div>' +
            '<div class="widerruf-field">' +
              '<label class="widerruf-field__label" for="widerruf-order">Bestellnummer *</label>' +
              '<input class="widerruf-field__input" type="text" id="widerruf-order" name="order_number" required placeholder="z. B. #1234">' +
              '<span class="widerruf-field__hint">Findest du in deiner Bestellbestätigungs-E-Mail.</span>' +
              '<span class="widerruf-field__error">Bitte gib deine Bestellnummer ein.</span>' +
            '</div>' +
            '<div class="widerruf-field">' +
              '<label class="widerruf-field__label" for="widerruf-email">E-Mail *</label>' +
              '<input class="widerruf-field__input" type="email" id="widerruf-email" name="email" required autocomplete="email">' +
              '<span class="widerruf-field__hint">Hier bekommst du die Eingangsbestätigung.</span>' +
              '<span class="widerruf-field__error">Bitte gib eine gültige E-Mail-Adresse ein.</span>' +
            '</div>' +
            addressFields +
            '<div class="widerruf-field">' +
              '<label class="widerruf-field__label" for="widerruf-reason">Begründung (optional)</label>' +
              '<textarea class="widerruf-field__textarea" id="widerruf-reason" name="reason" rows="3" placeholder="Hilft uns, besser zu werden — kein Pflichtfeld."></textarea>' +
            '</div>' +
            '<label class="widerruf-checkbox" id="widerruf-confirm-label">' +
              '<input type="checkbox" name="confirmed" required>' +
              '<span>Ich erkläre hiermit den Widerruf meines Kaufvertrags mit Minik Moon. *</span>' +
            '</label>' +
            '<button type="submit" class="widerruf-submit">Widerruf verbindlich bestätigen</button>' +
          '</form>' +
        '</div>' +
        '<div class="widerruf-step widerruf-step--loading" data-step="loading" hidden>' +
          '<h2 class="widerruf-modal__title">Einen Moment …</h2>' +
          '<p>Wir bestätigen deinen Widerruf' + (PHASE2_ENABLED ? ' und versuchen, dir direkt ein Retourenlabel zu erzeugen' : '') + '.</p>' +
          '<div class="widerruf-spinner" aria-label="Wird verarbeitet"></div>' +
        '</div>' +
        '<div class="widerruf-step widerruf-step--confirm" data-step="2" hidden>' +
          '<h2 class="widerruf-modal__title">Dein Widerruf ist eingegangen 🤍</h2>' +
          '<p>Vielen Dank, <span class="widerruf-eingang-name"></span>.</p>' +
          '<div class="widerruf-eingang">' +
            '<strong>Eingang bei Minik Moon:</strong><br>' +
            '<span class="widerruf-eingang-datum"></span><br>' +
            '<strong>Bestellnummer:</strong> <span class="widerruf-eingang-order"></span>' +
          '</div>' +
          '<div class="widerruf-label-block" data-label-block hidden>' +
            '<h3 class="widerruf-label-block__heading">Dein DHL-Retourenlabel ist bereit</h3>' +
            '<p>Tracking-Nummer: <strong class="widerruf-tracking"></strong></p>' +
            '<p class="widerruf-ret-nummer">Retouren-ID (RET-Nr.): <code class="widerruf-ret" style="user-select:all;-webkit-user-select:all;font-family:monospace;background:#f5f5f5;padding:2px 6px;border-radius:4px;"></code></p>' +
            '<a class="widerruf-download-btn" data-pdf-link href="#" target="_blank" rel="noopener" download="Minikmoon-Retoure-Label.pdf">' +
              '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">' +
                '<path d="M10 3v10m0 0l-4-4m4 4l4-4M3 17h14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
              '</svg>' +
              'Label als PDF herunterladen' +
            '</a>' +
            '<p class="widerruf-label-block__hint">Drucke das Label aus und klebe es auf dein Paket. Alternativ kannst du das Paket mit dem QR-Code (siehe E-Mail) labellos in einer DHL-Filiale abgeben.</p>' +
          '</div>' +
          '<div class="widerruf-label-fallback" data-label-fallback hidden>' +
            '<p class="widerruf-info">Wir melden uns mit den Versand-Anweisungen für deine Retoure per E-Mail innerhalb von 1-2 Werktagen.</p>' +
          '</div>' +
          '<p>Du bekommst gleich eine Eingangsbestätigung per E-Mail an <strong class="widerruf-eingang-email"></strong>.</p>' +
          '<div class="widerruf-kontakt">' +
            'Fragen? <a href="mailto:retoure@minikmoon.com">retoure@minikmoon.com</a> &middot; <a href="tel:+4917664138767">+49 176 64138767</a>' +
          '</div>' +
          '<button type="button" class="widerruf-close-final">Schließen</button>' +
        '</div>' +
      '</div>';
    return modal;
  }

  var lastFocused = null;

  function attachListeners(trigger, modal) {
    var openBtn = trigger.querySelector('.widerruf-button');
    var closeBtn = modal.querySelector('.widerruf-modal__close');
    var backdrop = modal.querySelector('.widerruf-modal__backdrop');
    var form = modal.querySelector('#widerruf-form');
    var closeFinalBtn = modal.querySelector('.widerruf-close-final');

    openBtn.addEventListener('click', function () { openModal(modal); });
    closeBtn.addEventListener('click', function () { closeModal(modal); });
    backdrop.addEventListener('click', function () { closeModal(modal); });
    closeFinalBtn.addEventListener('click', function () { closeModal(modal); });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal(modal);
    });

    form.addEventListener('submit', function (e) { handleSubmit(e, modal); });

    form.querySelectorAll('input, textarea').forEach(function (input) {
      input.addEventListener('input', function () {
        var field = input.closest('.widerruf-field, .widerruf-checkbox');
        if (field) field.classList.remove('widerruf-field--error', 'widerruf-checkbox--error');
      });
    });
  }

  function openModal(modal) {
    lastFocused = document.activeElement;
    modal.hidden = false;
    document.body.classList.add('widerruf-modal-open');
    setTimeout(function () {
      var firstInput = modal.querySelector('input, textarea');
      if (firstInput) firstInput.focus();
    }, 50);
  }

  function closeModal(modal) {
    modal.hidden = true;
    document.body.classList.remove('widerruf-modal-open');
    showStep(modal, '1');
    var form = modal.querySelector('#widerruf-form');
    if (form) form.reset();
    modal.querySelectorAll('.widerruf-field--error, .widerruf-checkbox--error').forEach(function (el) {
      el.classList.remove('widerruf-field--error', 'widerruf-checkbox--error');
    });
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  function showStep(modal, stepName) {
    modal.querySelectorAll('.widerruf-step').forEach(function (s) { s.hidden = true; });
    var target = modal.querySelector('[data-step="' + stepName + '"]');
    if (target) target.hidden = false;
  }

  function handleSubmit(e, modal) {
    e.preventDefault();
    var form = e.target;

    var fields = {
      name: form.elements['name'],
      order: form.elements['order_number'],
      email: form.elements['email'],
      reason: form.elements['reason'],
      confirmed: form.elements['confirmed']
    };
    if (PHASE2_ENABLED) {
      fields.street = form.elements['street'];
      fields.zip = form.elements['zip'];
      fields.city = form.elements['city'];
      fields.phone = form.elements['phone'];
    }

    var valid = true;
    var validations = [
      [fields.name, function (v) { return v.trim().length > 0; }],
      [fields.order, function (v) { return v.trim().length > 0; }],
      [fields.email, function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }]
    ];
    if (PHASE2_ENABLED) {
      validations.push(
        [fields.street, function (v) { return v.trim().length > 2; }],
        [fields.zip, function (v) { return /^[0-9]{5}$/.test(v); }],
        [fields.city, function (v) { return v.trim().length > 1; }]
      );
    }
    validations.forEach(function (pair) {
      if (!pair[1](pair[0].value)) {
        pair[0].closest('.widerruf-field').classList.add('widerruf-field--error');
        valid = false;
      }
    });
    if (!fields.confirmed.checked) {
      var label = document.getElementById('widerruf-confirm-label');
      if (label) label.classList.add('widerruf-checkbox--error');
      valid = false;
    }

    if (!valid) {
      var firstError = form.querySelector('.widerruf-field--error input, .widerruf-checkbox--error input');
      if (firstError) firstError.focus();
      return;
    }

    var now = new Date();
    var data = {
      name: fields.name.value.trim(),
      order_number: fields.order.value.trim(),
      email: fields.email.value.trim(),
      reason: (fields.reason.value || '').trim(),
      timestamp_iso: now.toISOString(),
      timestamp_human: now.toLocaleString('de-DE', { dateStyle: 'long', timeStyle: 'short' })
    };
    if (PHASE2_ENABLED) {
      data.street = fields.street.value.trim();
      data.zip = fields.zip.value.trim();
      data.city = fields.city.value.trim();
      data.phone = (fields.phone.value || '').trim();
    }

    var submitBtn = form.querySelector('.widerruf-submit');
    submitBtn.disabled = true;
    submitBtn.textContent = 'Wird gesendet …';
    showStep(modal, 'loading');

    // Klaviyo (Pflicht für § 356a BGB) — Phase 1
    Promise.allSettled([
      sendKlaviyoEvent(data, 'KUNDE', data.email, splitName(data.name)),
      sendKlaviyoEvent(data, 'INTERN_RETOURE', RETOURE_EMAIL, { first: 'Retoure', last: 'Team' })
    ]).then(function (results) {
      results.forEach(function (r, i) {
        if (r.status === 'rejected') console.error('[Widerruf] Klaviyo-Event ' + i + ':', r.reason);
      });
    });

    try {
      localStorage.setItem('minikmoon_widerruf_' + now.getTime(), JSON.stringify(data));
    } catch (err) {}

    // Phase 2: DHL-Label via Backend (nur wenn aktiviert)
    if (PHASE2_ENABLED) {
      requestDhlLabel(data).then(function (labelResult) {
        showConfirmation(modal, data, labelResult);
      }).catch(function (err) {
        console.warn('[Widerruf] Phase-2 fail, Phase-1-fallback:', err.message);
        showConfirmation(modal, data, null);
      });
    } else {
      setTimeout(function () { showConfirmation(modal, data, null); }, 800);
    }
  }

  function splitName(fullName) {
    var parts = fullName.split(' ');
    return { first: parts[0] || fullName, last: parts.slice(1).join(' ') || '' };
  }

  function sendKlaviyoEvent(data, empfaengerTyp, profileEmail, profileName) {
    var displayName = empfaengerTyp === 'INTERN_RETOURE'
      ? 'Retoure-Team (intern: Kunde ' + data.name + ')'
      : data.name;
    var body = {
      data: { type: 'event', attributes: {
        properties: {
          BestellNr: data.order_number,
          Email: profileEmail,
          Name: displayName,
          Kunde_Email: data.email,
          Kunde_Name: data.name,
          Begruendung: data.reason || '(keine Angabe)',
          Eingangsdatum_ISO: data.timestamp_iso,
          Eingangsdatum_lesbar: data.timestamp_human,
          Quelle: 'Refund-Policy-Page',
          _empfaenger_typ: empfaengerTyp
        },
        metric: { data: { type: 'metric', attributes: { name: KLAVIYO_EVENT_NAME } } },
        profile: { data: { type: 'profile', attributes: { email: profileEmail, first_name: profileName.first, last_name: profileName.last } } }
      }}
    };
    return fetch(KLAVIYO_EVENTS_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': KLAVIYO_API_REVISION },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.text().then(function (t) { throw new Error('Klaviyo ' + r.status + ': ' + t.slice(0, 200)); });
      return r;
    });
  }

  function requestDhlLabel(data) {
    return fetch(RETOURE_API + '/api/v1/verify-order', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ order_number: data.order_number, email: data.email })
    }).then(function (r) {
      if (!r.ok) throw new Error('verify_failed_' + r.status);
      return r.json();
    }).then(function (verifyRes) {
      if (!verifyRes.token) throw new Error('no_token');
      return fetch(RETOURE_API + '/api/v1/create-label', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          token: verifyRes.token,
          items: [{ id: 'unknown', quantity: 1 }],
          reason: data.reason,
          customer_phone: data.phone,
          customer_address: { name: data.name, address1: data.street, zip: data.zip, city: data.city, country: 'Germany' }
        })
      });
    }).then(function (r) {
      if (!r.ok) throw new Error('label_failed_' + r.status);
      return r.json();
    });
  }

  function showConfirmation(modal, data, labelResult) {
    showStep(modal, '2');

    setText(modal, '.widerruf-eingang-name', data.name);
    setText(modal, '.widerruf-eingang-datum', data.timestamp_human);
    setText(modal, '.widerruf-eingang-order', data.order_number);
    setText(modal, '.widerruf-eingang-email', data.email);

    var labelBlock = modal.querySelector('[data-label-block]');
    var fallbackBlock = modal.querySelector('[data-label-fallback]');

    if (labelResult && labelResult.ok && labelResult.labelPdfBase64) {
      var tracking = labelResult.trackingNumber || '';
      setText(modal, '.widerruf-tracking', tracking);
      // RET-Nummer: Pflichtanzeige für DHL Production-Freigabe
      // Format: "RET" + Sendungsnummer, kopierbarer Text (kein Bild)
      setText(modal, '.widerruf-ret', tracking ? 'RET' + tracking : '');
      var pdfLink = modal.querySelector('[data-pdf-link]');
      if (pdfLink) pdfLink.href = 'data:application/pdf;base64,' + labelResult.labelPdfBase64;
      if (labelBlock) labelBlock.hidden = false;
      if (fallbackBlock) fallbackBlock.hidden = true;
    } else if (labelResult && labelResult.status === 'manual_review') {
      if (fallbackBlock) {
        var infoEl = fallbackBlock.querySelector('.widerruf-info');
        if (infoEl && labelResult.message) infoEl.textContent = labelResult.message;
        fallbackBlock.hidden = false;
      }
      if (labelBlock) labelBlock.hidden = true;
    } else {
      if (labelBlock) labelBlock.hidden = true;
      if (fallbackBlock) fallbackBlock.hidden = false;
    }

    var title = modal.querySelector('[data-step="2"] h2');
    if (title) { title.setAttribute('tabindex', '-1'); title.focus(); }
  }

  function setText(root, selector, value) {
    var el = root.querySelector(selector);
    if (el) el.textContent = value;
  }
})();
